import { AnyAction, createAction, createReducer } from "@reduxjs/toolkit";

export const NOTIFICATION_ASYNC_ALL = createAction("NOTIFICATION_ASYNC_ALL");

export const NOTIFICATION_CREATE_PAYLOAD = createAction<{ [key: string]: any }>(
  "NOTIFICATION_CREATE_PAYLOAD"
);
export const NOTIFICATION_CREATE_SUCCESS = createAction<{ msg: string }>(
  "NOTIFICATION_CREATE_SUCCESS"
);
export const NOTIFICATION_CREATE_ERROR =
  createAction<{ msg: string }>("NOTIFICATION_CREATE_ERROR");

export const NOTIFICATION_CHANGED_EVENTS = createAction<{ [key: string]: any }>(
  "NOTIFICATION_CHANGED_EVENTS"
);

export const NOTIFICATION_LOADING_SUCCESS = createAction<{
  data: Array<Partial<any>>;
}>("NOTIFICATION_LOADING_SUCCESS");

export const NOTIFICATION_DELETE_ID = createAction<{ id: any }>(
  "NOTIFICATION_DELETE_ID"
);

const initalState: {
  id: number;
  loading: boolean;
  success: boolean | null;
  error: boolean | null;
  msg: string | null;
  result: Array<Partial<any>>;
  notifications: Array<Partial<any>>;
  count: number;
  page: number;
  pageSize: number;
  search: string;
  notification: Partial<any>;
} = {
  id: 0,
  loading: false,
  success: null,
  error: null,
  msg: null,
  result: [],
  notifications: [],
  count: 0,
  page: 0,
  pageSize: 6,
  search: "",
  notification: {},
};
const notificationsReducer = createReducer(initalState, (build) => {
  build
    .addCase(NOTIFICATION_CHANGED_EVENTS.type, (state, action: AnyAction) => {
      return {
        ...state,
        ...action.payload,
      };
    })
    .addCase(NOTIFICATION_CREATE_SUCCESS.type, (state, action: AnyAction) => {
      state.error = false;
      state.success = true;
      state.result = action.payload;
    })
    .addCase(NOTIFICATION_CREATE_ERROR.type, (state, action: AnyAction) => {
      state.error = false;
      state.success = false;
      state.msg = action.payload;
    })
    .addCase(NOTIFICATION_LOADING_SUCCESS.type, (state, action: AnyAction) => {
      return {
        ...state,
        notifications: action.payload.data,
        count: action.payload.count,
      };
    });
});

export default notificationsReducer;
